/**
 * RenderContext v2 — scoped resolveSymbol per block via stateContract.
 *
 * Re-exports the v1 RenderContext shape but adds blockName scoping.
 * Each block gets its own resolveSymbol that routes through its StateManager.
 */

import { createContext, useContext } from "react"
import type { RenderContextValue as V1RenderContextValue } from "@cogo/react-renderer"

export interface RenderContextV2Value extends V1RenderContextValue {
  /** Current block namespace for scoped symbol resolution */
  blockName?: string
  /** v2 schema version marker */
  schemaVersion: "3.0"
}

export const RenderContextV2 = createContext<RenderContextV2Value | null>(null)

export function useRenderContextV2(): RenderContextV2Value {
  const ctx = useContext(RenderContextV2)
  if (!ctx) throw new Error("RenderContextV2.Provider is missing")
  return ctx
}
